import { inject, Injectable } from '@angular/core';
import { IkpEnvironmentService } from '../environment/ikp-environment.service';
import { DataLayerService } from '@piwikpro/ngx-piwik-pro';
import { FaqCategory, FaqItem } from '../../model/faq.model';

@Injectable({ providedIn: 'root' })
export class TrackingService {
  private dataLayerService = inject(DataLayerService);
  private environmentService = inject(IkpEnvironmentService);

  private readonly ROOT_URL_NAME = 'frontpage';

  trackVirtualPageView(url: string) {
    this.track('virtualPageView', { title: this.getTitle(url), url });
  }

  trackFaq(faqItem: FaqItem, faqCategory: FaqCategory) {
    this.track('faq-interaction', {
      'faq-category': faqCategory.name,
      'faq-id': faqItem.id,
      'faq-name': faqItem.question,
      options: 'faq click',
    });
  }

  private track(event: string, contents: object) {
    const payload = { ...contents, event };
    this.logIfDebug(payload);
    this.dataLayerService.push(payload);
  }

  private logIfDebug(payload: object) {
    if (this.environmentService.isPiwikProTrackingDebugEnabled()) {
      console.log('Tracking event:', JSON.stringify(payload));
    }
  }

  private getTitle(url: string): string {
    const parts = url.split('/');

    if (this.hasIdParameter(parts)) {
      return `${parts[parts.length - 2]}-details`;
    }

    let title = parts[parts.length - 1].replace('=', '-');

    if (title.includes('#')) {
      title = this.handleHash(title);
    }

    return title || this.ROOT_URL_NAME;
  }

  private hasIdParameter(parts: string[]): boolean {
    return parts.length >= 3 && parts[parts.length - 1].length === 36;
  }

  private handleHash(title: string): string {
    const [base, hash] = title.split('#');
    return hash.startsWith('ey') ? base : base + hash;
  }
}
